import type { TranslationKey } from '@/i18n/translation-key';
import { z } from 'zod';

export const updateUserSchemaFactory = (t: (key: TranslationKey) => string) =>
  z.object({
    general: z.object({
      firstName: z.string().optional().describe('First name of the user'),
      lastName: z.string().optional().describe('Last name of the user'),
      phoneNumber: z
        .string()
        .optional()
        .refine(
          (val) => !val || val.trim() === '' || /^\+?[1-9][\d ]{1,14}$/.test(val),
          t('user.validation.phoneNumberFormat'),
        )
        .transform((val) => (val && val.trim() ? val.replace(/\s+/g, '') : undefined)),
      language: z.string().optional().describe('Language of the user'),
    }),
  });
